import React from 'react';
import { SelectedBillingAccountTable } from './progress-forms/selected-billing-account-table';
import { BillingProfileTable } from './progress-forms/billing-profile-table';
import { FormData } from './subscription-txa-transfer-pane';
import { InvoiceGroup, Maybe } from '@css-xp/graphtypes/src/generated-types-new';

type Props = {
  formState: FormData;
  selectBillingProfile: (billingProfile: InvoiceGroup) => void;
  changeBillingAccount: () => void;
  billingFrequency?: Maybe<string> | undefined;
  endTimestamp?: Maybe<number> | undefined;
};

const ManageBillingProfile = ({
  formState,
  selectBillingProfile,
  changeBillingAccount,
  billingFrequency,
  endTimestamp,
}: Props) => {
  return (
    <div className="invoice-groups-tab" data-testid="transaction-account-invoice-groups">
      <SelectedBillingAccountTable formState={formState} changeBillingAccount={changeBillingAccount} />
      <BillingProfileTable
        formState={formState}
        selectBillingProfile={selectBillingProfile}
        billingFrequency={billingFrequency}
        endTimestamp={endTimestamp}
      />
    </div>
  );
};

export default ManageBillingProfile;
